import { NotificationManager } from "react-notifications";

let lastMessage = null;
let lastType = null;

export const createNotification = (type, message, title, time = 3000) => {
  if (lastMessage === message && lastType === type) return;

  lastMessage = message;
  lastType = type;

  switch (type) {
    case 'info':
      NotificationManager.info(message, title, time);
      break;
    case 'success':
      NotificationManager.success(message, title, time);
      break;
    case 'warning':
      NotificationManager.warning(message, title, time);
      break;
    case 'error':
      NotificationManager.error(message, title, time);
      break;
    default:
      console.warn('Unknown notification type:', type);
  }

  // сбрасываем защиту через время жизни уведомления
  setTimeout(() => {
    lastMessage = null;
    lastType = null;
  }, time);
};
